<template>
  <section>
    <div class="d-flex align-items-center justify-content-between mb-1">
      <div>
        <h1 class="title">{{ $t('entity.devices') }}</h1>
      </div>
      <div style="width: 305px">
        <input
          type="text"
          class="form-control"
          :value="currentSerialNumber"
          @input="inputSerialNumber"
          :placeholder="currentSerialNumber ? currentSerialNumber : $t('src/pages/devices.enterSeriesNumber')"
        />
      </div>
    </div>
    <base-table
      :no-data="!hasDevices"
      :headers="headers"
      :loading="loading"
      :sorting="sorting"
      @filter="filterData"
      @sorting="changeSorting"
      @isReady="isReadyTable"
    >
      <template #tbody>
        <device-table-row v-for="device in devices" :key="device.id" :device="device" />
      </template>
    </base-table>
    <div class="mt-3">
      <paginator
        v-if="showPaginator"
        :total="totalCount"
        :per-page="perPage"
        v-model="currentPage"
        @change:count="numberOfElements"
      ></paginator>
    </div>
  </section>
</template>

<script>
import http from '@/modules/http.js'
import { stringify } from 'qs'
import { paginator } from '@/mixins/paginator.js'
import { getStatusListForFilter } from '@/modules/status-list.js'
import { userRights } from '@/mixins/user-rights.js'
import debounce from 'debounce'

export default {
  name: 'DevicesListAdmin',
  components: {
    BaseTable: () => import('@/base/BaseTable.vue'),
    DeviceTableRow: () => import('@/components/table-rows/DeviceAdminTableRow.vue')
  },
  mixins: [paginator, userRights],
  data: () => ({
    loading: true,
    devices: [],
    status: 0,
    sorting: {
      by: 'serial',
      order: 'asc'
    },
    isReady: false,
    currentSerialNumber: null
  }),
  computed: {
    statusListForFilter() {
      return getStatusListForFilter('device')
    },
    sortParams() {
      const sortOrder = this.sorting.order === 'asc' ? 1 : -1
      if (this.sorting.by === 'serial') {
        return {
          serial_number: sortOrder
        }
      } else if (this.sorting.by === 'model') {
        return {
          model: sortOrder
        }
      }
      return {
        id: 1
      }
    },
    params() {
      let params = { ...this.pageParams, $sort: this.sortParams }

      if (this.status) {
        params['device.status'] = this.status
      } else if (Object.prototype.hasOwnProperty.call(params, 'device.status')) {
        delete params['device.status']
      }
      if (this.$store.getters.IS_SELECTED_HOSPITAL) {
        params['hospital_id'] = this.$store.getters.SELECTED_HOSPITAL
      }

      if (this.currentSerialNumber) {
        params['serial_number'] = {
          $like: `%${this.currentSerialNumber}%`
        }
      }

      return params
    },
    hasDevices() {
      return this.devices.length > 0
    },
    headers() {
      return {
        model: {
          title: this.$t('devicesHeader.model'),
          class: 'th-name',
          sorting: 'asc'
        },
        serial: {
          title: this.$t('devicesHeader.serialNumber'),
          sorting: 'asc'
        },
        status: {
          title: this.$t('general.status'),
          class: 'th-mid',
          filter: true,
          options: this.statusListForFilter,
          selected: this.status
        },
        hospital: {
          title: this.$t('entity.hospitals')
        },
        lastUsed: {
          title: this.$t('general.lastUse')
        }
      }
    }
  },
  watch: {
    status() {
      this.loadData()
    }
  },
  created() {
    this.inputSerialNumber = debounce(this.inputSerialNumber, 500)
  },
  mounted() {
    if (this.$store.getters.IS_SELECTED_HOSPITAL) {
      this.$store.dispatch('RESET_HOSPITAL')
    }
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.isReady = false
      http
        .get('/devices', {
          params: this.params,
          paramsSerializer: params =>
            stringify(params, {
              arrayFormat: 'indices',
              encodeValuesOnly: true
            })
        })
        .then(response => response.data)
        .then(devices => {
          this.totalCount = devices.total
          this.devices = devices.data
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false))
    },
    filterData(event) {
      if (event.key === 'status') {
        this.status = +event.value
      }
    },
    changeSorting(sortingData) {
      this.sorting = sortingData
      this.loadData()
    },
    numberOfElements(number) {
      this.perPage = number
    },
    isReadyTable(value) {
      this.isReady = value
    },
    inputSerialNumber(e) {
      this.currentSerialNumber = e.target.value
      this.loadData().then(devices => {
        if (devices.length > 0) {
          this.devices = devices
        }
      })
    }
  }
}
</script>
